import React from "react";

import { FaLeaf, FaSeedling, FaTree } from "react-icons/fa";

export default {
  seedling: <FaSeedling />,
  budding: <FaLeaf />,
  evergreen: <FaTree />,
};
